import {
  Box,
  Button,
  ButtonBase,
  CardMedia,
  Dialog,
  IconButton,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: '30px',
    backgroundColor: '#FAFCFF',
    minHeight: '600px',
    padding: '60px 80px 0',
    [theme.breakpoints.down('lg')]: {
      minWidth: '700px',
    },
    [theme.breakpoints.up('lg')]: {
      minWidth: '1000px',
    },
    [theme.breakpoints.up('xl')]: {
      minWidth: '1200px',
    },
  },
  '& .MuiDialog-paperScrollPaper': {
    '&::-webkit-scrollbar': {
      width: '10px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.secondary.main,
      borderRadius: '10px',
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
      },
    },
    '&::-webkit-scrollbar-track': {
      margin: '60px 0',
    },
  },
}));

export const CloseIcon = styled(IconButton)(({ theme }) => ({
  right: '20px',
  top: '20px',
  position: 'absolute',
  '& span': {
    fontSize: '24px',
    fontWeight: '600',
    color: theme.palette.secondary.main,
  },
}));

export const SectionSubtitle = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  fontSize: '18px',
  fontWeight: '600',
  marginBottom: '20px',
  '& span': { color: theme.palette.secondary.main },
}));

export const ImageCard = styled(CardMedia)(({ theme }) => ({
  backgroundColor: '#bcbcbc66',
  width: '768px',
  height: '576px',
  borderRadius: '15px',
  alignSelf: 'center',
  backgroundSize: 'contain',
  objectFit: 'contain',
  margin: 'auto',
  marginBottom: 40,
  [theme.breakpoints.down('xl')]: {
    width: '640px',
    height: '480px',
  },
}));

export const FlexEndBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  gap: '10px',
}));

export const DownloadButton = styled(ButtonBase)(({ theme }) => ({
  float: 'right',
  height: '42px',
  width: '280px',
  border: '1px solid #737475',
  borderRadius: '16px',
  display: 'flex',
  gap: '10px',
  '& span': {
    color: theme.palette.secondary.main,
  },
  '&:hover': {
    backgroundColor: '#EDEFF2',
    borderColor: theme.palette.secondary.main,
  },
}));

export const SubmitBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  margin: '60px 0',
}));

export const SubmitButton = styled(Button)(({ theme }) => ({
  minWidth: '250px',
  backgroundColor: theme.palette.secondary.main,
  '&:hover': {
    filter: 'brightness(85%)',
  },
}));
